import { Minus, Plus } from 'lucide-react'
import { cn } from '@/lib/utils'

interface FormExpandLinkProps {
  expanded: boolean
  onToggle: () => void
  expandLabel: string
  hideLabel: string
  className?: string
}

/** Figma expand/collapse text control (+ Add… / − Hide). */
export function FormExpandLink({
  expanded,
  onToggle,
  expandLabel,
  hideLabel,
  className,
}: FormExpandLinkProps) {
  return (
    <button
      type='button'
      onClick={onToggle}
      className={cn(
        'inline-flex items-center gap-2 rounded-xl p-3 text-base font-medium leading-none hover:bg-[#f4f5f8]',
        expanded ? 'text-[#3d434e]' : 'text-[#ff5a1f]',
        className
      )}
    >
      {expanded ? (
        <Minus className='size-4 shrink-0' aria-hidden />
      ) : (
        <Plus className='size-4 shrink-0' aria-hidden />
      )}
      {expanded ? hideLabel : expandLabel}
    </button>
  )
}
